export default __webpack_public_path__ + "static/media/contact.976e3471.svg";